
import { Component, Prop, Vue } from "vue-property-decorator";
import t from "@common/src/i18n/t";

@Component({
  inheritAttrs: false
})
export default class SwitchStatus extends Vue {
  @Prop({ default: false, type: Boolean }) enable: Boolean;
  @Prop({ default: () => {}, type: Object }) rowData: any;
  @Prop({ default: () => {}, type: Function })
  updateMethod: any;
  @Prop({ default: "", type: String })
  enableTips: string;
  @Prop({
    default: t(`${t("setting.are-you-sure")}${t("base.disable")}${t("setting.pperation")}`),
    type: String
  })
  disableTips: string;
  changeStatus: boolean = false;
  confirmUpdateStatus(status) {
    this.updateMethod(status, this.rowData);
  }
  switchChange(status) {
    this.changeStatus = status;
  }
  switchChangeSure() {
    this.confirmUpdateStatus(Number(this.changeStatus));
  }
  switchEnable() {
    this.confirmUpdateStatus(1);
  }
}
